<template>
  <div class="exchange-course">

    <!-- 关联课程选择 -->
    <courseSelect v-model="selectCourseModal" :smsObjId="smsObjId" :smsType="smsType" @selectList="selectList"
      :activeQrcodeMode="0" :selectedCourses="exchangeForm.courseList"></courseSelect>

    <!-- 新增-兑换课程 -->
    <el-dialog title="新增-兑换课程" :visible.sync="dialogVisible">
      <el-form :model="exchangeForm" :rules="rules" ref="form" label-width="150px">
        <el-form-item label="兑换课程类型" prop="exchangeType" required>
          <el-radio-group v-model="exchangeForm.exchangeType" style="white-space: nowrap;" :aria-hidden="false">
            <!-- 防止换行 -->
            <el-radio label="手机号">手机号</el-radio>
            <el-radio label="核销码">核销码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" v-if="exchangeForm.exchangeType === '手机号'">
          <el-input v-model="exchangeForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="关联课程" prop="courseList" required>
          <el-button type="primary" @click="selectCourseModal = true">请选择课程</el-button>
          <el-table v-if="exchangeForm.courseList.length > 0" :data="exchangeForm.courseList" style="width: 100%;">
            <el-table-column prop="cover" label="封面" width="100">
              <template slot-scope="scope">
                <img :src="scope.row.img" alt="课程封面" style="width: 50px; height: 50px;">
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" width="150"></el-table-column>
            <el-table-column prop="price_fomat" label="价格(元)"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="removeCourse(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="开启状态" prop="status" required>
          <el-radio-group v-model="exchangeForm.status" :aria-hidden="false">
            <el-radio label="开启">开启</el-radio>
            <el-radio label="关闭">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 开启状态选择 开启  关闭 -->

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">{{ exchangeForm.exchangeType === '手机号' ? '确 定' : '生成核销码'
          }}</el-button>
      </span>
    </el-dialog>


    <!-- 筛选表单 -->
    <div class="filter-container">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="手机号">
          <el-input v-model="searchForm.phone" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="核销码">
          <el-input v-model="searchForm.code" placeholder="核销码"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="状态">
            <el-option label="已开启" value="1"></el-option>
            <el-option label="已关闭" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="searchForm.product_title" placeholder="课程名称"></el-input>
        </el-form-item>


        <el-collapse-transition>
          <span v-show="showAdvanced">
            <el-form-item label="创建时间">
              <el-date-picker v-model="searchForm.created_time_range" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
                @change="handleDateChange('created_time', $event)">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="核销时间">
              <el-date-picker v-model="searchForm.verify_time_range" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
                @change="handleDateChange('verify_time', $event)">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="开启时间">
              <el-date-picker v-model="searchForm.start_time_range" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
                @change="handleDateChange('start_time', $event)">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="关闭时间">
              <el-date-picker v-model="searchForm.end_time_range" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
                @change="handleDateChange('end_time', $event)">
              </el-date-picker>
            </el-form-item>
          </span>
        </el-collapse-transition>
        <el-form-item>
          <el-button type="text" @click="showAdvanced = !showAdvanced">
            {{ showAdvanced ? '隐藏高级筛选' : '高级筛选' }}
            <i :class="showAdvanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增兑换课程 -->
    <div>
      <el-button type="primary" @click="handleAddCourse">新增</el-button>
    </div>
    <!-- 兑换课程列表表格 -->
    <el-table :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :data="tableData" style="width: 100%; margin-top: 20px;">
  <div slot="empty">
    <img :src="require(`@/assets/image/empty.png`)" style="width: 100%; padding: 115px 0;" alt="暂无数据"/>
  </div>
  <el-table-column prop="id" label="序号" width="80"></el-table-column>
  <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
  <el-table-column prop="product_title" label="课程标题"></el-table-column>
  <el-table-column prop="start_time" label="开启时间" width="110"></el-table-column>
  <el-table-column prop="end_time" label="关闭时间" width="110"></el-table-column>
  <el-table-column prop="code" label="核销码" width="120"></el-table-column>
  <el-table-column prop="verify_time" label="核销时间" width="110"></el-table-column>
  <el-table-column prop="coupon_type_name" label="核销类型" width="100"></el-table-column>
  <el-table-column prop="create_time" label="创建时间" width="110"></el-table-column>
  <el-table-column prop="status_name" label="开启状态" width="110"></el-table-column>
  <el-table-column fixed="right" label="操作" width="220">
    <template slot-scope="scope">
      <span @click="handleStudyRecord(scope.row)" class="operation_title">学习记录</span>
      <span @click="handleToggleStatus(scope.row, 'close')" class="operation_title" v-if="scope.row.status == 2">关闭</span>
      <span @click="handleToggleStatus(scope.row, 'open')" class="operation_title" v-if="scope.row.status == 1">开启</span>
      <span @click="handleCopyCode(scope.row.code)" class="operation_title" v-if="scope.row.code">复制核销码</span>
    </template>
  </el-table-column>
</el-table>

    <!-- 分页 -->
    <el-pagination v-if="total > 10" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" style="margin-top: 20px;">
    </el-pagination>

    <!-- 学习记录抽屉 -->
    <drawer-learn v-model="drawerLearnFlag" :id="detail_id"></drawer-learn>

  </div>
</template>

<script>
import apis from '@/api/common/order.js'
import courseSelect from './courseSelect.vue'
import drawerLearn from '@/components/drawerLearn/drawerLearn.vue'

export default {
  name: 'ExchangeCourse',
  components: {
    courseSelect,
    drawerLearn
  },
  data() {
    return {
      dialogVisible: false,// 新增-兑换课程弹窗
      smsObjId: '',
      smsType: '',
      selectCourseModal: false,
      drawerLearnFlag: false,
      detail_id: '',

      exchangeForm: {
        phone: '',
        exchangeType: '手机号',
        status: '开启',
        courseList: [] // 课程列表数据
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        courseList: [
          {
            validator: (rule, value, callback) => {
              if (this.exchangeForm.courseList.length === 0) {
                callback(new Error('请选择课程'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        status: [
          { required: true, message: '请选择开启状态', trigger: 'change' }
        ]
      },

      searchForm: {
        phone: '',
        code: '',
        status: '',
        product_title: '',
        created_time_start: '',
        created_time_end: '',
        verify_time_start: '',
        verify_time_end: '',
        start_time_start: '',
        start_time_end: '',
        end_time_start: '',
        end_time_end: ''
      },
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      showAdvanced: false
    }
  },
  created() {
    this.getExchangeListAPI()
  },
  methods: {
    selectList(data) {
      console.log("data", data)
      this.exchangeForm.courseList = data
    },
    handleAddCourse() {
      this.exchangeForm.courseList = []
      this.exchangeForm.phone = ''
      this.dialogVisible = true;
    },
    async getExchangeListAPI(params) {
      params = { ...this.searchForm, page: this.currentPage, page_size: this.pageSize }
      try {

        const res = await apis.exchangeListAPI(params);
        console.log("res", res)
        this.tableData = res.data;
        this.total = res.count;
      } catch (error) {
        console.log("error", error)
        this.$message.error("获取列表失败");
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getExchangeListAPI();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getExchangeListAPI();
    },
    search() {
      this.currentPage = 1;
      this.getExchangeListAPI();
    },
    handleDateChange(type, dateRange) {
      if (dateRange) {
        this.searchForm[`${type}_start`] = dateRange[0];
        this.searchForm[`${type}_end`] = dateRange[1];
      } else {
        this.searchForm[`${type}_start`] = '';
        this.searchForm[`${type}_end`] = '';
      }
    },
    handleStudyRecord(row) {
      console.log("row", row)
      this.drawerLearnFlag = true
      this.detail_id = row.order_id
    },
    async handleToggleStatus(row, action) {
      try {
        await this.$confirm(`确定要${action === 'open' ? '开启' : '关闭'}该兑换课程吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        const status = action === 'open' ? 2 : 1;
        const res = await apis.exchangeStatusAPI({
          id: row.id,
          status: status
        });
        this.$message.success(`${action === 'open' ? '开启' : '关闭'}成功`);
        this.getExchangeListAPI();
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(error.message);
        }
      }
    },
    handleCopyCode(code) {
      // 复制核销码逻辑
      console.log('复制核销码', code);
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(() => {
          this.$message.success('核销码已复制');
        }).catch(err => {
          this.$message.error('复制失败');
          console.error('复制失败:', err);
          this.fallbackCopyText(code);
        });
      } else {
        this.fallbackCopyText(code);
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('核销码已复制');
        } else {
          this.$message.error('复制失败');
        }
      } catch (err) {
        this.$message.error('复制失败');
        console.error('复制失败:', err);
      }
      document.body.removeChild(textArea);
    },
    async submitForm(formName) {
      try {
        await this.$refs[formName].validate();
      } catch (error) {
        return false;
      }

      const params = {
        coupon_type: this.exchangeForm.exchangeType === '手机号' ? 1 : 2,
        product_id: this.exchangeForm.courseList.map(course => course.id).join(','),
        status: this.exchangeForm.status === '开启' ? 2 : 1
      };
      if (this.exchangeForm.exchangeType === '手机号') {
        params.phone = this.exchangeForm.phone;
      }
      console.log("params", params)
      try {
        const res = await apis.exchangeAddAPI(params);
        console.log("res", res)
        this.$message.success("添加成功");
        this.dialogVisible = false;
        this.getExchangeListAPI();
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    removeCourse(index) {
      this.exchangeForm.courseList.splice(index, 1);
    }
  }
}
</script>

<style scoped>
.exchange-course {
  padding: 20px;

  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
  }
}

.operation_title {
  color: #409eff;
  cursor: pointer;
  margin-right: 10px;
}

.operation_title:hover {
  color: #66b1ff;
}
</style>